import React from "react";
import { Stack } from "@mui/material";

export const SicheroVideo: React.FC = () => {
  return (
    <Stack width={1} position="relative" paddingTop="56.25%">
      <iframe
        src="https://www.youtube.com/embed/p7ZHPEVZ5jU"
        title="YouTube Video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      />
    </Stack>
  );
};
